export async function compileWASMModule(binaryFilePath: string): Promise<WebAssembly.WebAssemblyInstantiatedSource> {
  if (!window.WebAssembly) {
    throw new Error('Webassembly not supported');
  }

  const wasmFileResponse = await fetch(`${ binaryFilePath }/rnnoise-processor.wasm`);

  return await WebAssembly.instantiate(await wasmFileResponse.arrayBuffer());
}
